export interface ProjectState {
  projects?: Project[]
  selectedRows: number
  currentPage: number
  selectedProjectIds: string[]
}
export const GET_LIST_PROJECTS = 'GET_LIST_PROJECTS'
export const SELECTED_PROJECT_IDS = 'SELECTED_PROJECT_IDS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS'
